import React from 'react';
import Locations from './locations';
import Paths from '../../shared/components/paths';
import Metatags from './meta-tags';
import FooterLinks from './footer-links';
import FooterSearch from './footer-search';
import ZAddButton from '../../z-button-add';

const rowStyle = {
  display: 'flex',
  width: '100%',
  justifyContent: 'space-between',
};

const OptimizationView = ({
  entityId,
  title,
  onFooterSearch,
  scrollTargetEle,
  onTopSectionClick,
}) => {
  return (
    <>
      <h2>Admin Settings</h2>
      <Paths
        entityId={entityId}
        entityTitle={title}
        entityType="LandingPageCategory"
        pathPrefix=""
      />
      <div style={rowStyle}>
        <Locations
          entityId={entityId}
        />
      </div>
      <br/>
      <Metatags
        entityId={entityId}
      />
      <br/>
      <h3>SEO Footer Links</h3>
      <FooterSearch
        onFooterSearch={onFooterSearch}
      />
      <br/>
      <div style={{display: 'flex', flexDirection: 'row-reverse'}}>
        <ZAddButton onClick={onTopSectionClick}>Add Section</ZAddButton>
      </div>
      <br/>
      <FooterLinks
        entityId={entityId}
      />
      <div ref={scrollTargetEle}/>
      <br/>
    </>
  )
}

export default OptimizationView;
